import db from '@/firebase/firestore.js'
export default {
    methods: {
        mi_userData: function (userUID, result) {
            try{
                var resultSetter = function (user, result) {
                    if (result.userName != undefined) {
                        result.userName = user.userName
                    }
                    if (result.avaterURL != undefined) {
                        if (user.avaterImage != null) {
                            result.avaterURL = user.avaterImage.url
                        } else {
                            result.avaterURL = null
                        }
                    }
                }

                const self = this
                var users = this.$store.getters["cachedUsers"]
                const index = users.findIndex((user) => user.userUID === userUID)
                if (index < 0) {
                    db.collection("users").doc(userUID).get().then(function(doc){
                        var user = doc.data()
                        users.push(user)
                        resultSetter(user, result)
                    })
                } else {
                    var user = users[index]
                    resultSetter(user, result)
                    this.__compressCache()
                }
    
            } catch (error) {
                console.log(error)
            }
        },
        __compressCache: function () {
            var cache = []
            const self = this
            const currentCache = this.$store.getters["cachedUsers"]
            currentCache.forEach(function(user, i){
                if (cache.length > 0) {
                    const index = cache.findIndex((u) => u.userUID == user.userUID)
                    if (index < 0) {
                        cache.push(user)
                    }
                } else {
                    cache.push(user)
                }
                if (i == currentCache.length - 1) {
                    self.$store.commit("cachedUsers", cache)
                }
            })
        }
    }
}
